import { Button, Drawer, Space, Spin } from 'antd';
import MappingReviewChecklist from './mappingReviewChecklist';
import React, { useState } from 'react';
import ReviewComments from './reviewComments';

const ReviewDrawer = props => {
  const { toggleModal, fileId, mappingReviewId, dataSource } = props;
  const [isLoading, setLoading] = useState(true);
  const [checklistType, setChecklistType] = useState('requester');
  const [status, setReviewStatus] = useState('in progress');

  const handleCancel = () => {
    toggleModal(false);
  };

  const renderActionButton = () => {
    if (!checklistType) return null;
    const btnText = checklistType === 'requester' ? 'reviewer' : 'requester';
    const onClickFunc = () => setChecklistType(btnText);
    return (
      <Space>
        <Button onClick={onClickFunc} type="primary" disabled={status === 'in progress'}>
          View {btnText} Checklist
        </Button>
      </Space>
    );
  };

  return (
    <Drawer
      title="Mapping Review"
      placement="right"
      width={600}
      onClose={handleCancel}
      visible
      extra={renderActionButton()}
      destroyOnClose
      data-cy="mapping-review-drawer"
    >
      <Spin spinning={isLoading} delay={0}>
        <MappingReviewChecklist
          dataSource={dataSource}
          fileId={fileId}
          mappingReviewId={mappingReviewId}
          toggleModal={toggleModal}
          setLoading={x => setLoading(x)}
          checklistType={checklistType}
          setReviewStatus={x => setReviewStatus(x)}
          getMappingReview={props.getMappingReview}
        />
        <ReviewComments mappingReviewId={mappingReviewId} checklistType={checklistType} />
      </Spin>
    </Drawer>
  );
};

export default ReviewDrawer;
